module.exports = __webpack_public_path__ + "static/media/9c216316d4ef3d6502477824f849c3b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/Catalog/9c216316d4ef3d6502477824f849c3b8.png
// module id = 890
// module chunks = 0